import { AppliedConfigProvider } from "contexts/applied-config/AppliedConfigProvider";
import { SystemOverviewLayout } from "layouts/OverviewLayout";

export const SystemOverviewPage = () => {
  return (
    <AppliedConfigProvider>
      <SystemOverviewLayout />
    </AppliedConfigProvider>
  );
};
